import { checkboxSlotRecipe } from './checkbox.recipe';
import { dialogSlotRecipe } from './dialog.recipe';
import { drawerSlotRecipe } from './drawer.recipe';
import { selectSlotRecipe } from './select.recipe';

export const slotRecipes = {
  drawer: drawerSlotRecipe,
  checkbox: checkboxSlotRecipe,
  dialog: dialogSlotRecipe,
  select: selectSlotRecipe,
};
